module.exports = __webpack_public_path__ + "img/Headhunter.fe15d972.svg";